import Helper from "@/common/helper.js"

export default class ReportingMemberCategoryUsageModel {
    
    timestamp: string| undefined;
    memberNumber: string | undefined;
    memberName: string| undefined;
    categoryName: string| undefined;
    item: string | undefined;
    price: number| undefined;    
    balls: number| undefined;        

    get timestampDisplay(): string {
        let local = Helper.convertUTCDateToLocalDate(new Date(this.timestamp!))
        return local.toDateString().substring(4) + ", " + local.toLocaleTimeString()
    }

    static from(json: string): ReportingMemberCategoryUsageModel {
        let model = Object.assign(new ReportingMemberCategoryUsageModel(), json);
                
        return model;
    }

  }

  
